<template>
  <div class="rich-text-editor">
    <QuillEditor
      v-model:content="editorContent"
      :toolbar="toolbarOptions"
      content-type="html"
      theme="snow"
      :placeholder="placeholder"
      @update:content="onContentChange"
    />
    <input
      type="hidden"
      :name="inputName"
      :value="editorContent"
    />
  </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  name: 'RichTextEditor',
  components: { QuillEditor },
  props: {
    inputName: {
      type: String,
      required: true
    },
    initialContent: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Write your answer here...'
    }
  },
  data () {
    return {
      editorContent: this.initialContent || ''
    }
  },
  computed: {
    toolbarOptions () {
      return [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
        ['clean']
      ]
    }
  },
  methods: {
    onContentChange (content) {
      this.editorContent = content
    }
  }
}
</script>

<style scoped>
.rich-text-editor {
  width: 100%;
}

.rich-text-editor :deep(.ql-container) {
  min-height: 150px;
  font-size: 14px;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.rich-text-editor :deep(.ql-toolbar) {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  background-color: #f9fafb;
}

.rich-text-editor :deep(.ql-editor) {
  min-height: 150px;
}

.rich-text-editor :deep(.ql-toolbar.ql-snow),
.rich-text-editor :deep(.ql-container.ql-snow) {
  border-color: #d1d5db;
}

.rich-text-editor :deep(.ql-toolbar.ql-snow:focus-within + .ql-container.ql-snow),
.rich-text-editor :deep(.ql-container.ql-snow:focus-within) {
  border-color: #302EA0;
}
</style>
